import { DocumentsTypes } from './actionTypes';

const INIT_STATE = {
  documentList: [],
  documentData: {},
  error: '',
  success: false,
  isLoading: false,
  isLoadingBase64: false,

  documentListInnoboDocs: [],
};

const Documents = (state = INIT_STATE, action: any) => {
  switch (action.type) {
    case DocumentsTypes.GET_DOCUMENTS:
      return {
        ...state,
        documentData: {},
        documentList: [],
        isLoading: true,
      };
    case DocumentsTypes.GET_DOCUMENTS_SUCCESS:
      return {
        ...state,
        documentList: action.payload,
        isLoading: false,
      };
    case DocumentsTypes.GET_DOCUMENTS_FAIL:
      return {
        ...state,
        error: action.payload,
        documentList: [],
        isLoading: false,
      };
    case DocumentsTypes.GET_ONE_DOCUMENT:
      return {
        ...state,
        isLoadingBase64: true,
      };
    case DocumentsTypes.GET_ONE_DOCUMENT_SUCCESS:
      return {
        ...state,
        documentData: action.payload,
        isLoadingBase64: false,
      };
    case DocumentsTypes.GET_ONE_DOCUMENT_FAIL:
      return {
        ...state,
        error: action.payload,
        documentData: {},
        isLoadingBase64: false,
      };
    //-------------------------------------------Innobo docs-------------------------------------------------
    case DocumentsTypes.GET_DOCUMENTS_INNOBO_DOCS:
      return {
        ...state,
        documentDataInnoboDocs: {},
        documentListInnoboDocs: [],
        isLoading: true,
        success: false
      };
    case DocumentsTypes.GET_DOCUMENTS_SUCCESS_INNOBO_DOCS:
      return {
        ...state,
        documentListInnoboDocs: action.payload,
        isLoading: false,
      };
    case DocumentsTypes.GET_DOCUMENTS_FAIL_INNOBO_DOCS:
      return {
        ...state,
        error: action.payload,
        isLoading: false,
      };

    //--UPDATE---------
    case DocumentsTypes.UPLOAD_DOCUMENT_INNOBO_DOCS:
      return {
        ...state,
        isLoading: true,
      };
    case DocumentsTypes.UPLOAD_DOCUMENT_SUCCESS_INNOBO_DOCS:
      return {
        ...state,
        isLoadingBase64: false,
      };
    case DocumentsTypes.UPLOAD_DOCUMENT_FAIL_INNOBO_DOCS:
      return {
        ...state,
        error: action.payload,
        isLoadingBase64: false,
      };

    //--DELETE---------

    case DocumentsTypes.DELETE_DOCUMENT_INNOBO_DOCS:
      return {
        ...state,
        isLoading: true,
        success: false
      };
    case DocumentsTypes.DELETE_DOCUMENT_SUCCESS_INNOBO_DOCS:
      return {
        ...state,
        isLoading: false,
        success: true
      };
    case DocumentsTypes.DELETE_DOCUMENT_FAIL_INNOBO_DOCS:
      return {
        ...state,
        error: action.payload,
        isLoading: false,
      };

    default:
      break;
  }
  return state;
};

export default Documents;
